import { Injectable } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ROLE } from '../models/auth';
import { fetchAuthSession, fetchUserAttributes, getCurrentUser, signInWithRedirect, signOut } from 'aws-amplify/auth';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public loginState = false;
  public errorState: { message: string } | null = null;
  private userInfo?: any;
  public entitlements: any[] = [];
  private userRole = '';

  public readonly groupRoleMap: Record<string, string> = {
    'idh-portal-admins': ROLE.ADMIN,
  };

  constructor(private nzMessageService: NzMessageService) {}

  async logout() {
    await signOut();
    this.loginState = false;
  }

  async fetchUserDetails(): Promise<boolean> {
    try {
      const user = await getCurrentUser();
      const { tokens: session } = await fetchAuthSession();
      const attributes = await fetchUserAttributes();

      const groups = (session?.accessToken?.payload['cognito:groups'] as string[] | undefined) ?? [];
      const userGroups = groups.filter((group: string) => !group.endsWith('Okta'));

      this.userInfo = { ...user, ...attributes, groups };

      // TODO: Call Get Entitlements once ready
      this.setUserRole(userGroups);
      return true;
    } catch (err) {
      console.warn(`${err} while getting current user info`);
      return false;
    }
  }

  setUserRole(userGroups: string[] | null | undefined): void {
    if (!userGroups || userGroups.length === 0) {
      return;
    }

    const primaryGroup = userGroups[0];
    this.userRole = this.groupRoleMap[primaryGroup];
  }

  getUserInfo(): any {
    return this.userInfo;
  }

  getUserRole(): string {
    return this.userRole;
  }

  async validateLogin(): Promise<boolean> {
    try {
      const authSession = await fetchAuthSession({ forceRefresh: true });
      if (authSession.credentials) {
        this.loginState = true;
      }
      return true;
    } catch (_err) {
      console.log('_err', _err);
      return false;
    }
  }

  public federatedOktaSignIn(): void {
    signInWithRedirect({
      provider: { custom: 'idh-dev-Okta' }, // TODO: Make it dynamic
      customState: '/',
    }).catch((err) => {
      console.log('err', err);
    });
  }

  public hasEntitlements(entitlements: string[]): boolean {
    return entitlements.some((entitlement) => this.entitlements.includes(entitlement));
  }
}
